import { isNil } from 'ramda';

export const isNumber = <T = any>(num: number | undefined | null | T): num is number => {
  return !isNil(num) && typeof num === 'number';
};
